import { isAxiosError } from 'axios';
import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { sitecoreAxios } from './core.axios.js';
import { buildUrl } from './util.build-url.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS,
  capacity: 1e4
});
function getBreadcrumbs(portalConfig, path, options) {
  const pathUrl = new URL(path, "http://localhost");
  if (pathUrl.pathname === "/" || pathUrl.pathname === portalConfig.homePath || pathUrl.pathname === portalConfig.searchPath) {
    return [];
  }
  const url = buildUrl(
    `/api/v1/portals/${portalConfig.id}/breadcrumbs?path=${encodeURIComponent(
      pathUrl.pathname
    )}`,
    options
  );
  return cache(!(options == null ? void 0 : options.disableCache) ? url : void 0, async () => {
    var _a;
    try {
      const response = await sitecoreAxios.get(url, {});
      return response.data.Breadcrumbs.map((breadcrumb) => breadcrumb.Id);
    } catch (err) {
      if (isAxiosError(err) && ((_a = err.response) == null ? void 0 : _a.status) === 404) {
        return;
      }
      throw err;
    }
  }).getStaleWhileRevalidate();
}

export { getBreadcrumbs };
//# sourceMappingURL=request.get-breadcrumbs.js.map
